import React from "react";
import styled from "styled-components";
import { Element, scroller } from "react-scroll";

import { Logo } from "../../components/logo";
import { DownArrow } from "../../components/downArrow";
import { Marginer } from "../../components/marginer";
import BackgroundImg from "../../assets/pictures/Via_Vorderseite_2.jpg";
import { Navbar } from "../../components/navbar";

const TopContainer = styled.div`
  width: 100%;
  height: 50%;
  padding: 0;
  background-image: url(${BackgroundImg});
`;

const BackgroundFilter = styled.div`
  width: 100%;
  height: 50%;
  background-color: rgba(55, 55, 55, 0.89);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const DownArrowContainer = styled.div`
  position: absolute;
  bottom: 25px;
  left: 50%;
  transform: translateX(-50%);
`;

const ContactText = styled.h2`
  font-size: 25px;
  font-weight: 500;
  line-height: 1.4;
  color: #fff;
  margin: 0;
  text-align: center;
`;

export function HeaderContact(props) {
  return (
    <Element name="headerContact">
      <TopContainer>
        <BackgroundFilter>
          <Navbar />
          <Marginer direction="vertical" margin="2em" />
          <Logo />
          <Marginer direction="vertical" margin="2em" />
          <ContactText>Robert-Bosch-Straße 1</ContactText>
          <ContactText>35460 Staufenberg</ContactText>
          <ContactText>+4964069090884</ContactText>
          <ContactText>info@via-verwertungen.com</ContactText>
          <Marginer direction="vertical" margin="2em" />
        </BackgroundFilter>
      </TopContainer>
    </Element>
  );
}